import React, { Component } from 'react';
import './header.css';
import Overlay from '../overlay/overlay';

class HeaderBar extends Component {
  constructor(props) {
    super(props);
    this.handleOverlay = this.handleOverlay.bind(this);
    this.state = {
      overlayFlag: false
    }
  }

  handleOverlay() {
    this.setState(state => ({
      overlayFlag: !state.overlayFlag
    }));
  }

  render() {    
    return (
      <div className="flex-justify-space-between toolbar">
        <img src={require('../assets/profile.jpeg')}
             alt="hamburger icon" 
             className="logo" />

        <img src={require('../assets/ham-icon.png')}
             alt="hamburger icon" 
             className="hamIcon" 
             onClick={this.handleOverlay}/>

        <ul className="flex-justify-space-between style-none toolbar-nav-list">
          <li>
            <a href="/home">Home</a>
          </li>
          <li>
            <a href="/work">Work</a>
          </li>
          <li>
            <a href="https://drive.google.com/file/d/1Jq-pif_GjPUlkD8NwuBHH2Yq1DRVFyWz/view?usp=sharing"
               rel="noopener noreferrer"
               target="_blank">
              Resume
            </a>
          </li>
        </ul>

        <Overlay toggleOverlay={this.state.overlayFlag}/>
      </div>
    );
  }
}  

export default HeaderBar;
